const HOME_ROUTE = '/';
const LOGIN_ROUTE = '/login';
const USER_ROUTE = '/account/:userId';

export { LOGIN_ROUTE, HOME_ROUTE, USER_ROUTE };
